import { useSelector } from "react-redux";
import {
  selectIsAdmin,
  selectIsConsultOnlySession,
  selectIsMarketplaceAdmin,
  selectIsPharmacist,
} from "../store/auth-slice";
import { resolveDefaultRoute } from "../utils/defaultRoute";

/** ITAM-2622: the one landing route, shared by App and every internal redirect. */
export const useDefaultRoute = (): string => {
  const isAdmin = useSelector(selectIsAdmin);
  const isMarketplaceAdmin = useSelector(selectIsMarketplaceAdmin);
  const isPharmacist = useSelector(selectIsPharmacist);
  const isConsultOnly = useSelector(selectIsConsultOnlySession);

  return resolveDefaultRoute({
    isAdmin,
    isMarketplaceAdmin,
    isPharmacist,
    isConsultOnly,
  });
};
